import React, { useState, useEffect } from "react";

function Pokemon({ url }) {
  const [data, setData] = useState(null);

  useEffect(() => {
    if (url) {
      fetch(url)
        .then((res) => res.json())
        .catch((error) => console.error(error))
        .then((dat) => {
          if (dat) {
            setData(dat);
          }
        });
    }
  }, [url]);

  return (
    <div className="pokemon">
      <div className="card">
        <div className="card-header">
          <h2>{data ? `${data.id}. ${data.name}` : ""}</h2>
        </div>
        <div className="card-image">
          <img src={data ? data.sprites.front_default : ""} alt="Pokemon" />
        </div>
        <div className="card-body">
          <div className="poke-title">Stats</div>
          {data
            ? data.stats.map((el, i) => (
                <div className={i % 2 === 1 ? "poke-stats par" : "poke-stats"}>
                  <div>{el.stat.name}</div>
                  <div>{el.base_stat}</div>
                </div>
              ))
            : ""}
          <div className="poke-title">Types</div>
          <div className="poke-types">
            {data ? data.types.map((el) => <div>{el.type.name}</div>) : ""}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Pokemon;
